import React from "react";
import {color} from "common/tokens";

// Drawn rather than shipped as bitmaps: inline SVG takes its colours from the
// tokens, stays crisp at any size and costs about a kilobyte. The palette was
// sampled from the brand's own role artwork — golden skin, near-black hair,
// cyan for the mentee, coral for the mentor.
//
// Each role is a pair of head-and-shoulders figures cropped at the bottom edge,
// the way the original illustrations were composed. Clothing colour carries the
// role and a motif backs it up, so the two are never told apart by colour
// alone: a graduation cap for the mentee, a collar and tie for the mentor.

const HEAD_Y = 32;
const HEAD_R = 16;
const CROP = 104;

// Torso with shoulders sloping up to a narrow neck, tucked under the chin so
// the head does not read as floating above it.
const Figure = ({x, shirt, bun = false}) => (
  <>
    <path
      d={`M ${x - 25} ${CROP} L ${x - 25} 66 Q ${x - 24} 50 ${x - 9} 47 L ${x + 9} 47 Q ${x + 24} 50 ${x + 25} 66 L ${x + 25} ${CROP} Z`}
      fill={shirt}
    />
    <circle cx={x} cy={HEAD_Y} r={HEAD_R} fill={color.ART_SKIN}/>
    {bun && <circle cx={x} cy={HEAD_Y - 23} r={6.5} fill={color.ART_HAIR}/>}
    <path
      d={`M ${x - HEAD_R} ${HEAD_Y} Q ${x - HEAD_R} ${HEAD_Y - 17} ${x} ${HEAD_Y - 17} Q ${x + HEAD_R} ${HEAD_Y - 17} ${x + HEAD_R} ${HEAD_Y} Q ${x + HEAD_R - 5} ${HEAD_Y - 9} ${x} ${HEAD_Y - 9} Q ${x - HEAD_R + 5} ${HEAD_Y - 9} ${x - HEAD_R} ${HEAD_Y} Z`}
      fill={color.ART_HAIR}
    />
  </>
);

const BACK = 32;
const FRONT = 88;

export const MenteeArt = ({className}) => (
  <svg viewBox={'0 0 120 104'} className={className} role={'presentation'} focusable={'false'}>
    <Figure x={BACK} shirt={color.ART_MENTEE} bun/>
    <Figure x={FRONT} shirt={color.ART_MENTEE}/>
    <path d={`M ${FRONT} 3 L ${FRONT + 22} 13 L ${FRONT} 23 L ${FRONT - 22} 13 Z`} fill={color.ART_HAIR}/>
    <path
      d={`M ${FRONT + 18} 15 L ${FRONT + 18} 27 Q ${FRONT + 18} 31 ${FRONT + 21} 31 Q ${FRONT + 24} 31 ${FRONT + 24} 27 L ${FRONT + 24} 14 Z`}
      fill={color.ART_HAIR}
    />
  </svg>
);

export const MentorArt = ({className}) => (
  <svg viewBox={'0 0 120 104'} className={className} role={'presentation'} focusable={'false'}>
    <Figure x={BACK} shirt={color.ART_MENTOR} bun/>
    {/* A drape folded over one shoulder */}
    <path d={`M ${BACK - 4} 47 L ${BACK + 17} 76 L ${BACK + 17} ${CROP} L ${BACK + 4} ${CROP} Z`} fill={color.ART_SHADE}/>
    <Figure x={FRONT} shirt={color.ART_MENTOR}/>
    <path
      d={`M ${FRONT - 12} 49 L ${FRONT} 66 L ${FRONT + 12} 49 L ${FRONT + 7} 47 L ${FRONT} 56 L ${FRONT - 7} 47 Z`}
      fill={color.SURFACE}
    />
    <path d={`M ${FRONT} 60 L ${FRONT + 5} 67 L ${FRONT} 90 L ${FRONT - 5} 67 Z`} fill={color.ART_HAIR}/>
  </svg>
);
